"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdentityImportImpulse = void 0;
var IdentityImportImpulse = /** @class */ (function () {
    function IdentityImportImpulse(uri, tenantId, identityId, identityName, override) {
        this.uri = uri;
        this.tenantId = tenantId;
        this.identityId = identityId;
        this.identityName = identityName;
        this.override = override;
    }
    return IdentityImportImpulse;
}());
exports.IdentityImportImpulse = IdentityImportImpulse;
//# sourceMappingURL=IdentityImportImpulse.js.map